(function () {
  // Swym uses XHR (not fetch) for cart adds and never dispatches the theme's
  // cart:update event. Intercept XHR to /cart/add.js and fire it ourselves.
  var _xhrOpen = XMLHttpRequest.prototype.open;
  var _xhrSend = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.open = function (method, url) {
    this._twpCartAdd = method === 'POST' && typeof url === 'string' && url.indexOf('/cart/add') !== -1;
    return _xhrOpen.apply(this, arguments);
  };
  XMLHttpRequest.prototype.send = function () {
    if (this._twpCartAdd) {
      this.addEventListener('load', function () {
        if (this.status >= 200 && this.status < 300) {
          fetch('/cart.js')
            .then(function (r) { return r.json(); })
            .then(function (cart) {
              document.dispatchEvent(new CustomEvent('cart:update', {
                bubbles: true,
                detail: { data: { itemCount: cart.item_count } }
              }));
            });
        }
      });
    }
    return _xhrSend.apply(this, arguments);
  };

  var MAX_RETRIES = 25;
  var RETRY_MS = 200;
  var retries = 0;
  var refreshTimer = null;

  var HEART_OUTLINE = '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M19.6706 5.4736C17.6806 3.8336 14.7206 4.1236 12.8906 5.9536L12.0006 6.8436L11.1106 5.9536C9.29063 4.1336 6.32064 3.8336 4.33064 5.4736C2.05064 7.3536 1.93063 10.7436 3.97063 12.7836L11.6406 20.4536C11.8406 20.6536 12.1506 20.6536 12.3506 20.4536L20.0206 12.7836C22.0706 10.7436 21.9506 7.3636 19.6706 5.4736Z" stroke="currentColor" stroke-width="1.7" fill="none" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  var HEART_FILLED = '<svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg"><path d="M19.6706 5.4736C17.6806 3.8336 14.7206 4.1236 12.8906 5.9536L12.0006 6.8436L11.1106 5.9536C9.29063 4.1336 6.32064 3.8336 4.33064 5.4736C2.05064 7.3536 1.93063 10.7436 3.97063 12.7836L11.6406 20.4536C11.8406 20.6536 12.1506 20.6536 12.3506 20.4536L20.0206 12.7836C22.0706 10.7436 21.9506 7.3636 19.6706 5.4736Z" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  // Inject base styles globally — hearts appear on PDP and Tagalys tiles too,
  // not just native cards (where product-card.liquid provides the same rules).
  var styleEl = document.createElement('style');
  styleEl.textContent = '.twp-wishlist-heart{position:absolute;top:16px;right:16px;z-index:10;background:none;border:none;padding:0;cursor:pointer;color:var(--color-foreground);display:flex;align-items:center;justify-content:center;line-height:0;}';
  document.head.appendChild(styleEl);

  // Remove Swym's injected header icon — keep observing; Swym may re-inject after route changes
  function removeSwymHeaderIcon() {
    var el = document.getElementById('swym-advanced-header-icon');
    if (el) el.remove();
  }
  var headerIconObserver = new MutationObserver(removeSwymHeaderIcon);
  headerIconObserver.observe(document.documentElement, { childList: true, subtree: true });
  removeSwymHeaderIcon();

  function scheduleHeaderRefresh() {
    if (refreshTimer) clearTimeout(refreshTimer);
    refreshTimer = setTimeout(function () {
      refreshTimer = null;
      try { window.SwymAdvancedHeaderIconAPI.refreshCount(); } catch (e) {}
      try { window.SwymGhostWishlistDrawer._updateHeaderCount(); } catch (e) {}
    }, 300);
  }

  // Own in-memory Set — source of truth for heart state in this page session.
  // _swat.addToWishList succeeds (cloud sync) but does NOT write back to SwymLocalWishlist
  // ghost store, so we can't rely on getItems() after add/remove. We seed from the ghost
  // store at init time and update the Set ourselves on each successful add/remove.
  var wishlistPaths = null;

  function initWishlistPaths() {
    wishlistPaths = {};
    try {
      var items = window.SwymLocalWishlist.getItems() || [];
      for (var i = 0; i < items.length; i++) {
        var item = items[i];
        if (!item.du) continue;
        try {
          wishlistPaths[new URL(item.du).pathname.split('?')[0]] = true;
        } catch (e) {}
      }
    } catch (e) {}
  }

  function isWishlisted(productPath) {
    return !!wishlistPaths && !!wishlistPaths[productPath];
  }

  function setButtonState(btn, wishlisted) {
    btn.innerHTML = wishlisted ? HEART_FILLED : HEART_OUTLINE;
    btn.setAttribute('aria-pressed', wishlisted ? 'true' : 'false');
    btn.setAttribute('aria-label', wishlisted ? 'Remove from wishlist' : 'Add to wishlist');
  }

  // Header heart: solid heart-fill icon whenever the wishlist contains anything.
  // Toggles a class on the header link(s); the icon swap is CSS in header-actions.liquid.
  function updateHeaderHeart() {
    var hasItems = false;
    for (var key in wishlistPaths) {
      hasItems = true;
      break;
    }
    var links = document.querySelectorAll('.header-actions__wishlist-link');
    for (var i = 0; i < links.length; i++) {
      links[i].classList.toggle('header-actions__wishlist-link--has-items', hasItems);
    }
  }

  function refreshHeartStates() {
    var btns = document.querySelectorAll('.twp-wishlist-heart[data-product-path]');
    for (var i = 0; i < btns.length; i++) {
      var btn = btns[i];
      setButtonState(btn, isWishlisted(btn.getAttribute('data-product-path')));
    }
    updateHeaderHeart();
  }

  // Write add/remove through to the ghost store so state survives page navigation.
  // _swat syncs to cloud but doesn't update the ghost store itself.
  var GHOST_KEY = 'swym-ghost-' + window.location.hostname;

  function ghostStoreAdd(item) {
    try {
      var ghost = JSON.parse(localStorage.getItem(GHOST_KEY) || '{}');
      ghost.items = (ghost.items || []).filter(function (i) { return i.du !== item.du; });
      ghost.items.push({
        empi: item.empi, epi: item.epi, du: item.du,
        dt: item.dt, iu: item.iu, pr: item.pr, stk: 1, synced: true
      });
      localStorage.setItem(GHOST_KEY, JSON.stringify(ghost));
    } catch (e) {}
  }

  function ghostStoreRemove(du) {
    try {
      var ghost = JSON.parse(localStorage.getItem(GHOST_KEY) || '{}');
      ghost.items = (ghost.items || []).filter(function (i) { return i.du !== du; });
      localStorage.setItem(GHOST_KEY, JSON.stringify(ghost));
    } catch (e) {}
  }

  function handleClick(btn, productPath) {
    // Ignore clicks while a previous add/remove for this button is in flight.
    // Without this guard, a fast double-click reads the same wasWishlisted value
    // twice and fires overlapping _swat calls whose callbacks resolve out of
    // order, so an add can be silently undone (intermittent "didn't register").
    if (btn.dataset.twpBusy === '1') return;
    btn.dataset.twpBusy = '1';
    var release = function () { delete btn.dataset.twpBusy; };

    var wasWishlisted = isWishlisted(productPath);

    // Optimistic UI + in-memory state update
    if (wasWishlisted) {
      delete wishlistPaths[productPath];
    } else {
      wishlistPaths[productPath] = true;
    }
    setButtonState(btn, !wasWishlisted);
    updateHeaderHeart();

    fetch(productPath + '.js')
      .then(function (r) { return r.json(); })
      .then(function (product) {
        var variant = product.variants[0];
        var item = {
          empi: product.id,
          epi: variant.id,
          du: window.location.origin + productPath,
          pr: variant.price / 100,
          iu: product.featured_image,
          dt: product.title
          // no qt — Swym API rejects it as a disallowed key
        };
        var revert = function () {
          if (wasWishlisted) {
            wishlistPaths[productPath] = true;
          } else {
            delete wishlistPaths[productPath];
          }
          setButtonState(btn, wasWishlisted);
          updateHeaderHeart();
          release();
        };
        if (wasWishlisted) {
          window._swat.removeFromWishList(item, function () {
            ghostStoreRemove(item.du);
            scheduleHeaderRefresh();
            release();
          }, revert);
        } else {
          window._swat.addToWishList(item, function () {
            ghostStoreAdd(item);
            scheduleHeaderRefresh();
            release();
          }, revert);
        }
      })
      .catch(function () {
        if (wasWishlisted) {
          wishlistPaths[productPath] = true;
        } else {
          delete wishlistPaths[productPath];
        }
        setButtonState(btn, wasWishlisted);
        updateHeaderHeart();
        release();
      });
  }

  function makeHeartButton(path) {
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'twp-wishlist-heart';
    btn.setAttribute('data-product-path', path);
    setButtonState(btn, isWishlisted(path));
    btn.addEventListener('click', function (e) {
      e.stopPropagation();
      handleClick(btn, path);
    });
    return btn;
  }

  function injectHearts(root) {
    if (!wishlistPaths || !window._swat) return false;
    var added = 0;

    // Native Horizon product cards
    var tiles = (root || document).querySelectorAll('product-card.product-card');
    for (var i = 0; i < tiles.length; i++) {
      var tile = tiles[i];
      if (tile.querySelector('.twp-wishlist-heart')) continue;
      var link = tile.querySelector('a[href*="/products/"]');
      if (!link) continue;
      var path = link.getAttribute('href').replace(/^https?:\/\/[^/]+/, '').split('?')[0];
      if (!path) continue;
      tile.appendChild(makeHeartButton(path));
      added++;
    }

    // Tagalys tiles (a.product-link containing .product-image-container)
    var tagalysLinks = (root || document).querySelectorAll('a.product-link[href*="/products/"]');
    for (var j = 0; j < tagalysLinks.length; j++) {
      var tLink = tagalysLinks[j];
      var imgContainer = tLink.querySelector('.product-image-container');
      var container = imgContainer || tLink;
      if (container.querySelector('.twp-wishlist-heart')) continue;
      var tPath = tLink.getAttribute('href').replace(/^https?:\/\/[^/]+/, '').split('?')[0];
      if (!tPath) continue;
      if (imgContainer) imgContainer.style.position = 'relative';
      container.appendChild(makeHeartButton(tPath));
      added++;
    }

    // Collection carousel cards (bespoke .twp-collection-carousel markup — not
    // product-card or a.product-link). Heart sits in the image wrapper, which is
    // already position:relative.
    var carouselCards = (root || document).querySelectorAll('.twp-collection-carousel__card');
    for (var k = 0; k < carouselCards.length; k++) {
      var cWrap = carouselCards[k].querySelector('.twp-collection-carousel__image-wrapper');
      if (!cWrap || cWrap.querySelector('.twp-wishlist-heart')) continue;
      var cLink = carouselCards[k].querySelector('a[href*="/products/"]');
      if (!cLink) continue;
      var cPath = cLink.getAttribute('href').replace(/^https?:\/\/[^/]+/, '').split('?')[0];
      if (!cPath) continue;
      cWrap.appendChild(makeHeartButton(cPath));
      added++;
    }

    return added > 0;
  }

  var isPdp = window.location.pathname.indexOf('/products/') !== -1;
  var isWishlistPage = window.location.pathname.indexOf('/pages/swym-wishlist') !== -1;

  // On the wishlist page Swym's own widget owns the list, and it renders from
  // Swym's cloud — the local ghost store lags (cloud-only items added in other
  // sessions/devices may be missing from it). So reconcile our Set from the
  // cloud, which is authoritative for both adds AND the "remove all" case, and
  // fully rebuild (adds and removes) so the header heart tracks the list. The
  // additive mergeGhostStore/storage paths never catch a same-tab clear (the
  // storage event only fires in other tabs), hence this dedicated reconcile.
  function reconcileFromCloud() {
    if (!wishlistPaths || !window._swat || typeof window._swat.fetch !== 'function') return;
    try {
      window._swat.fetch(function (items) {
        if (!wishlistPaths) return;
        var next = {};
        var list = items || [];
        for (var i = 0; i < list.length; i++) {
          var du = list[i] && list[i].du;
          if (!du) continue;
          try {
            var p = du.indexOf('http') === 0 ? new URL(du).pathname.split('?')[0] : du.split('?')[0];
            if (p) next[p] = true;
          } catch (e) {}
        }
        wishlistPaths = next;
        refreshHeartStates();
      });
    } catch (e) {}
  }

  var reconcileTimer = null;
  function scheduleReconcile() {
    if (reconcileTimer) clearTimeout(reconcileTimer);
    reconcileTimer = setTimeout(function () {
      reconcileTimer = null;
      reconcileFromCloud();
    }, 400);
  }

  function injectPdpHeart() {
    if (!wishlistPaths || !window._swat) return false;
    var info = document.querySelector('.product-details');
    if (!info || info.querySelector('.twp-wishlist-heart')) return false;
    var path = window.location.pathname.split('?')[0];
    info.style.position = 'relative';
    info.appendChild(makeHeartButton(path));
    return true;
  }

  // Fetch the authoritative wishlist from Swym's cloud API and merge it in.
  // The ghost store only reliably holds items this theme wrote itself — items
  // added in previous sessions, via Swym's own UI, or on another device may be
  // missing from it, so hearts (incl. the header icon) would start unfilled.
  var cloudFetched = false;
  function fetchCloudWishlist() {
    if (cloudFetched || !window._swat || typeof window._swat.fetch !== 'function') return;
    cloudFetched = true;
    try {
      window._swat.fetch(function (items) {
        if (!items || !items.length || !wishlistPaths) return;
        var changed = false;
        for (var i = 0; i < items.length; i++) {
          var du = items[i] && items[i].du;
          if (!du) continue;
          try {
            var path = du.indexOf('http') === 0 ? new URL(du).pathname : du.split('?')[0];
            if (path && !wishlistPaths[path]) {
              wishlistPaths[path] = true;
              changed = true;
            }
          } catch (e) {}
        }
        if (changed) refreshHeartStates();
      });
    } catch (e) {
      cloudFetched = false;
    }
  }

  // Merge ghost store into wishlistPaths (additive only — doesn't remove session adds).
  // Called after a delay to catch Swym's cloud→ghost sync completing post-init.
  function mergeGhostStore() {
    if (!wishlistPaths || !window.SwymLocalWishlist) return;
    var changed = false;
    try {
      var items = window.SwymLocalWishlist.getItems() || [];
      for (var i = 0; i < items.length; i++) {
        var item = items[i];
        if (!item.du) continue;
        try {
          var p = new URL(item.du).pathname.split('?')[0];
          if (!wishlistPaths[p]) { wishlistPaths[p] = true; changed = true; }
        } catch (e) {}
      }
    } catch (e) {}
    if (changed) refreshHeartStates();
  }

  function tryInject() {
    if (!window.SwymLocalWishlist || !window._swat) {
      retries++;
      if (retries < MAX_RETRIES) setTimeout(tryInject, RETRY_MS);
      return;
    }

    // Init our wishlist state from the ghost store once Swym is ready
    if (!wishlistPaths) initWishlistPaths();
    updateHeaderHeart();
    fetchCloudWishlist();

    var injectedCards = injectHearts(document);
    var injectedPdp = isPdp ? injectPdpHeart() : false;
    if (!injectedCards && !injectedPdp) {
      retries++;
      if (retries < MAX_RETRIES) setTimeout(tryInject, RETRY_MS);
    }

    // Swym's cloud→ghost sync completes async after init — merge it in once it lands
    setTimeout(mergeGhostStore, 2000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', tryInject);
  } else {
    tryInject();
  }

  // Re-inject on DOM mutations (pagination, infinite scroll, Tagalys re-renders)
  var scanTimer = null;
  new MutationObserver(function () {
    if (scanTimer) clearTimeout(scanTimer);
    scanTimer = setTimeout(function () {
      scanTimer = null;
      injectHearts(document);
      if (isPdp) injectPdpHeart();
      if (isWishlistPage) {
        // Swym re-rendered the list (e.g. an item or the whole list was
        // removed) — reconcile from the cloud once the DOM settles
        scheduleReconcile();
      } else {
        // Header sections can re-morph and wipe the has-items class — re-apply
        updateHeaderHeart();
      }
    }, 150);
  }).observe(document.body, { childList: true, subtree: true });

  // Merge ghost store into our Set when another Swym widget updates localStorage
  // (e.g. HP carousel adds a product — picks up on next page via ghost store seed,
  // or same-tab via storage event if the ghost store key changes).
  window.addEventListener('storage', function (e) {
    if (!e.key || e.key.toLowerCase().indexOf('swym-ghost') === -1) return;
    if (!wishlistPaths) return;
    try {
      var data = JSON.parse(e.newValue || '{}');
      var items = data.items || [];
      for (var i = 0; i < items.length; i++) {
        var item = items[i];
        if (!item.du) continue;
        try {
          wishlistPaths[new URL(item.du).pathname.split('?')[0]] = true;
        } catch (ex) {}
      }
      refreshHeartStates();
    } catch (ex) {}
  });
})();
